import React from 'react';
import PropTypes from 'prop-types';

import {
  ErrorTag,
  InfoTag,
  OkTag,
  WarningTag,
} from '../../../../components/Tags';
import { LeadCampaignStatus } from '../../../../Model/MassTextCampaign';
import { EM_DASH } from '../utils/constants';
import texts from '../texts.json';

const { statusLabels } = texts.history;

const STATUS_CONFIG = {
  [LeadCampaignStatus.SUCCESSFUL]: { Tag: OkTag, label: statusLabels.SUCCESSFUL },
  [LeadCampaignStatus.IN_PROGRESS]: { Tag: InfoTag, label: statusLabels.IN_PROGRESS },
  [LeadCampaignStatus.PARTIALLY_COMPLETED]: { Tag: WarningTag, label: statusLabels.PARTIALLY_COMPLETED },
  [LeadCampaignStatus.FAILED]: { Tag: ErrorTag, label: statusLabels.FAILED },
  [LeadCampaignStatus.CREATED]: { Tag: InfoTag, label: statusLabels.CREATED },
  [LeadCampaignStatus.SCHEDULED]: { Tag: InfoTag, label: statusLabels.SCHEDULED },
  [LeadCampaignStatus.WINDOW_MISSED]: { Tag: WarningTag, label: statusLabels.WINDOW_MISSED },
  [LeadCampaignStatus.SUSPENDED]: { Tag: WarningTag, label: statusLabels.SUSPENDED },
};

const StatusTag = ({ status }) => {
  const config = STATUS_CONFIG[status];
  if (!config) return EM_DASH;
  const { Tag, label } = config;
  return <Tag>{label}</Tag>;
};

StatusTag.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusTag;
